import request from "@/utils/request";

// 查询
export function getClientEnterpriseServiceList(data) {
  return request({
    url: "/system/clientEnterprise/getClientEnterpriseServiceList",
    method: "post",
    data
  });
}

// 新增
export function insertClientEnterprise(data) {
  return request({
    url: "/system/clientEnterprise/insertClientEnterprise",
    method: "post",
    data
  });
}

// 修改
export function updateClientEnterprise(data) {
  return request({
    url: "/system/clientEnterprise/updateClientEnterprise",
    method: "post",
    data
  });
}

// 删除
export function deleteByIdList(data) {
  return request({
    url: "/system/clientEnterprise/deleteByIdList",
    method: "post",
    data
  });
}

// 单个查询
export function getClientEnterpriseOne(data) {
  return request({
    url: "/system/clientEnterprise/getClientEnterpriseOne",
    method: "get",
    params: data
  });
}

// 导入数据
export function importClientEnterprise(data) {
  return request({
    url: "/system/clientEnterprise/importClientEnterprise",
    method: "post",
    data
  });
}
//同步智参企业名称（全称）和标签到总台和贵阳电信
export function synchronousData(data) {
  return request({
    url: "/system//clientEnterprise/synchronousData",
    method: "post",
    data
  });
}

// 25-4-1 新增
// 智参企业基本信息
export function getClientEnterpriseBaseInfo(params) {
  return request({
    url: "/system/clientEnterprise/getBasicInfo",
    method: "get",
    params
  });
}

// 查询经营信息
export function getBusinessInfo(params) {
  return request({
    url: "/system/clientEnterprise/getBusinessInfo",
    method: "get",
    params
  });
}

// 查询组织信息
export function getOrganizationInfo(params) {
  return request({
    url: "/system/clientEnterprise/getOrganizationInfo",
    method: "get",
    params
  });
}

// 查询关联信息
export function getRelationInfo(params) {
  return request({
    url: "/system/clientEnterprise/getRelationInfo",
    method: "get",
    params
  });
}

// 根据产业链id查询产业链
export function getChainCode(params) {
  return request({
    url: "/system/clientEnterprise/getChainCode",
    method: "get",
    params
  });
}

// 修改经营信息
export function updateBusinessInfo(data) {
  return request({
    url: "/system/clientEnterprise/updateBusinessInfo",
    method: "post",
    data
  });
}

// 修改智参企业基本信息
export function updateBasicInfo(data) {
  return request({
    url: "/system/clientEnterprise/updateBasicInfo",
    method: "post",
    data
  });
}

// 导入天眼查企业数据
export function importTycCompany(data) {
  return request({
    url: "/system/clientEnterprise/importTycCompany",
    method: "post",
    data
  });
}
